import { create, fromBinary, toBinary } from '@bufbuild/protobuf';

import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import { EmptyResponseError } from 'APP/model/error/errors/EmptyResponseError';
import api, { ServerErrorCode } from 'APP/restApi';
import {
  DiscoverBaseUrlRequestSchema,
  DiscoverRequestSchema,
  RouterDeeplinkRequestSchema,
} from 'APP/wsApi/routerContractApi/types/router/router_requests_pb';
import {
  DiscoverBaseUrlResponseSchema,
  DiscoverResponseSchema,
  RouterResponseSchema,
} from 'APP/wsApi/routerContractApi/types/router/router_responses_pb';

import {
  mapGetDiscoverBaseUrlRequest,
  mapGetDiscoverBaseUrlResponse,
  mapGetDiscoverDestinationsRequest,
  mapGetDiscoverDestinationsResponse,
  mapGetUnauthorizedRoutingResponse,
} from './tenantRouterModel.mapper';
import {
  IDiscoverDestination,
  IGetDiscoverDestinationsRequestParams,
  ITenantDeepLinkRouterLogin,
  ITenantDeepLinkRouterUrls,
} from './tenantRouterModel.types';

export const getDeepLinkRoutingUrls = async (
  data: ITenantDeepLinkRouterLogin
): Promise<ITenantDeepLinkRouterUrls> => {
  try {
    const payload = create(RouterDeeplinkRequestSchema, data);
    const result = await api.router.getDeeplinkRouting(
      toBinary(RouterDeeplinkRequestSchema, payload)
    );
    const response = fromBinary(RouterResponseSchema, new Uint8Array(result));

    if (!response.success?.configs.length) {
      throw new Error(ServerErrorCode.Unauthorized);
    }

    return mapGetUnauthorizedRoutingResponse(response.success);
  } catch (error) {
    logger.get('API').error('tenantRouter.getDeepLinkRoutingUrls', error);
    throw buildModelError(error);
  }
};

export async function updateDestinationBaseUrl(destination: IDiscoverDestination): Promise<string> {
  try {
    const payload = create(DiscoverBaseUrlRequestSchema, mapGetDiscoverBaseUrlRequest(destination));
    const result = await api.router.getDestinationBaseUrl(
      toBinary(DiscoverBaseUrlRequestSchema, payload)
    );

    const response = fromBinary(DiscoverBaseUrlResponseSchema, new Uint8Array(result));

    if (!response.success?.baseUrl) {
      throw new Error(ServerErrorCode.Unauthorized);
    }

    return mapGetDiscoverBaseUrlResponse(response);
  } catch (error) {
    logger.get('API').error('tenantRouter.getDestinationBaseUrl', error);
    throw buildModelError(error);
  }
}

export async function getDiscoverDestinations(
  params: IGetDiscoverDestinationsRequestParams
): Promise<IDiscoverDestination[]> {
  try {
    const request = mapGetDiscoverDestinationsRequest(params);
    const payload = create(DiscoverRequestSchema, request);
    const result = await api.router.getDiscoverDestinationsRequest(
      toBinary(DiscoverRequestSchema, payload)
    );

    const response = fromBinary(DiscoverResponseSchema, new Uint8Array(result));

    if (!response.success?.destinations.length) {
      throw new EmptyResponseError('getWorkspace', response);
    }

    return mapGetDiscoverDestinationsResponse(response.success);
  } catch (error) {
    logger.get('API').error('tenantRouter.getDiscoverDestinations', error);
    return [];
  }
}
